
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function fitmentTableTabMobileRT () {
    return this.vehicleSpecific || this.manyFitments ? _createElement('div', { 'key': '0' }, _createElement('span', { 'className': 'text' }, 'Fitment'), _createElement('span', { 'className': 'icon-plus' }, ' ')) : null;
}
        export const componentNames = []